const PageSubTitle = ({children}) => {
    return (
        <>{children}</>
    )
}

export default PageSubTitle
